var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticClass: "vDialogClass",
      attrs: {
        persistent: "",
        fullscreen: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition"
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        { staticStyle: { position: "fixed", overflow: "auto" } },
        [
          _c(
            "CabeceraModal",
            { attrs: { titulo: _vm.title }, on: { cerrar: _vm.handleCerrar } },
            [
              !(_vm.selectedAction == "detail")
                ? _c("GuardarButton", {
                    attrs: { disabled: _vm.disabledSave },
                    on: { click: _vm.handleSave }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("v-card", { attrs: { height: "55px", flat: "" } }, [
            _c(
              "div",
              { attrs: { id: "formDiv" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "rounded-card",
                    staticStyle: { margin: "25px 25px 0px 25px" }
                  },
                  [
                    _c(
                      "v-container",
                      {
                        staticStyle: {
                          padding: "10px !important",
                          "padding-bottom": "0px !important"
                        },
                        attrs: { "grid-list-md": "" }
                      },
                      [
                        _c(
                          "FormFieldsContainer",
                          { attrs: { titulo: "ID Tag" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "ID Tag",
                                clearable: "",
                                disabled: _vm.showDetail
                              },
                              model: {
                                value: _vm.idtag,
                                callback: function($$v) {
                                  _vm.idtag = $$v
                                },
                                expression: "idtag"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }